/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {find} from 'lodash';
import {TextInput} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import SchoolsSelectComponent from './SchoolsSelectComponent';

export default class SchoolChangeModal extends Component {
    static get propTypes() {
        return {
            activeCollection: PropTypes.object.isRequired,
            currentUserGeo: PropTypes.object.isRequired,
            schoolsList: PropTypes.object.isRequired,
            searchSchoolByPostalCode : PropTypes.object.isRequired,
            saveSelectedSchool: PropTypes.object.isRequired
        };
    }
  
    constructor (props) {
        super(props);
    
        this.state = {
            institutionList: [],
            postalCodeSearchString: '',
            schoolsLoaded: false,
            selectedSchoolInfo: {}
        };
        
        this.changezipCode = this.changezipCode.bind(this);
        this.displayInstitutionList = this.displayInstitutionList.bind(this);
        this.prepareCurrentUserGeoString = this.prepareCurrentUserGeoString.bind(this);
        this.searchSchoolsByPostalCode = this.searchSchoolsByPostalCode.bind(this);
        this.saveSelectedSchool = this.saveSelectedSchool.bind(this);
        this.applySelectedSchool = this.applySelectedSchool.bind(this);
        this.loadUserContextBasedSettings = this.loadUserContextBasedSettings.bind(this);
    }
  
    changezipCode(evt){
        evt.preventDefault();
        this.displayInstitutionList(evt);
    }
  
    displayInstitutionList(evt) {
        const enteredPostalCode = evt.target.value;
        if (enteredPostalCode.length >= 3 && this.state.postalCodeSearchString === '') {
            this.setState({postalCodeSearchString: enteredPostalCode});
            if (this.props.searchSchoolByPostalCode) {
                this.searchSchoolsByPostalCode(enteredPostalCode);
            }
        } else if (enteredPostalCode.length < 3) {
            this.setState({
                schoolsLoaded: false,
                postalCodeSearchString: '',
                selectedSchoolInfo: {}
            });
        }
    }
  
    searchSchoolsByPostalCode(enteredPostalCode){
        return this.props.searchSchoolByPostalCode(this.prepareCurrentUserGeoString(), enteredPostalCode.substr(0, 3)).then(() => {
            this.setState({schoolsLoaded: true});
        });
    }
  
    prepareCurrentUserGeoString() {
        switch (this.props.currentUserGeo) {
            case 'US': {
                return 'USA';
            }
            case 'CA': {
                return 'CAN';
            }
            default : {
                return 'USA';
            }
        }
    }
  
  handleChange = (selectedOption) => {
      // selectedOption can be null when the `x` (close) button is clicked
      if (selectedOption) {
          console.log(`Selected: ${selectedOption.label}`);
      }
  };
  
  saveSelectedSchool(schoolId){
      const selectedSchoolInfo = find(this.props.schoolsList, function (s){
          return s.schoolId === schoolId;
      });
      this.setState({selectedSchoolInfo});
  }
  
  applySelectedSchool(){
      const selectedSchoolInfo = this.state.selectedSchoolInfo;
      
      // save call
      this.props.saveSelectedSchool(
          this.props.activeCollection.collectionId,
          selectedSchoolInfo.schoolId,
          this.state.postalCodeSearchString,
          null,
          this.props.onRequestClose
      );
      
  }
  
  loadUserContextBasedSettings(){
      if (this.props.currentUserGeo === 'US') {
          return {noResultsError: <FormattedMessage id={'courseInformation.school.select_no_school_error_US'}/>};
      } else {
          return {noResultsError: <FormattedMessage id={'courseInformation.school.select_no_school_error_CA'}/>};
      }
  }

  render() {
      const {schoolsList} = this.props;
      const isInvalidInstitute = () => {
          if (this.state.schoolsLoaded && !(schoolsList && schoolsList.length > 0)) {
              return "error";
          } else {
              return "default";
          }
      };
      
      return (
          <div className="modal-content-container">
              <div className="school-change">
                  <div className='row-wrapper margin-left-zero'>
                      <label className="pe-label--small"><i>Enter the school zip code, then select the institution</i></label>
                  </div>
                  <div className='row-wrapper inputs margin-left-zero'>
                      <div className="zipcode-text-wrap">
                          <div className="text-input-wrapper">
                              <TextInput id="zipCode"
                                  labelText="Zip Code"
                                  fancy={false}
                                  changeHandler={this.changezipCode}
                                  inputState ={isInvalidInstitute()}
                              />
                          </div>
                          <div className="">
                              {this.state.schoolsLoaded && !(schoolsList && schoolsList.length > 0 )
                          && <label className="no-results-error-label pe-textLabelInput__label" htmlFor="noResultsError" >{this.loadUserContextBasedSettings().noResultsError}</label>}
                          </div>
                      </div>
                      
                  </div>
                  {this.state.schoolsLoaded === true && (schoolsList && schoolsList.length > 0)
                    && <div className='school-change-component'>
                        <label className="pe-title--secondary" htmlFor="schools"><FormattedMessage id={'courseInformation.school.name_of_institution'}/></label>
                        <div className="pe-select-container selects">
                            <SchoolsSelectComponent
                                saveSelectedSchool={this.saveSelectedSchool}
                                institutionList={schoolsList}
                                currentUserGeo={this.props.currentUserGeo}/>
                        </div>
                    </div>
                  }
          
              </div>
              <div className="modal-footer">
                  <button type="button" className="pe-btn--btn_small close-btn" data-dismiss="modal" onClick={() => {this.props.onRequestClose();}}>Close</button>
                  <button type="button" id="saveSchoolList" className="pe-btn__primary--btn_small" disabled={ (this.state.selectedSchoolInfo && this.state.selectedSchoolInfo.schoolId) ? "":"true"} onClick={() => {this.applySelectedSchool();}}>Apply</button>
              </div>
          </div>
      );
  }
}




// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/InstitutionChangeComponent/SchoolChangeModal.js